import { Icon } from '../icon/icon.component';
import { style } from './onboarding-card.module.css';

interface Props {
  symbol: string | number;
  title: string;
  description: string;
}

export function OnboardingCard(props: Props) {

  const { symbol, title, description } = props;

  return (
    <div className={style.card}>
      {typeof symbol === 'number' ?
        <span className={style.number}>{symbol}</span> :
        <div className={style.iconContainer}>
          <Icon icon={symbol} className={style.icon}/>
        </div>
      }
      <div>
        <h2 className={style.title}>{title}</h2>
        <p className={style.description}>{description}</p>
      </div>
    </div>
  );
}
